export default __webpack_public_path__ + "static/media/github-icon.08dab27a.svg";